// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"01cd303b","453":"08d0374e","796":"b5c1d4fc"}[chunkId] + ".chunk.js";
};